import { PHeadline, PGrid, PGridItem, PText, PFlexItem, PFlex } from '@porsche-design-system/components-react'
import queryString from 'query-string'
import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { getReporting, getSentiment, getKeyPhrases, getAll, getRatingsByConfigIds } from '../../shared/utils/api/Apps'

// import CommentSummary from '../../shared/components/CommentSummary/CommentSummary'
import Content from '../../shared/components/Content/Content'
import ContentMain from '../../shared/components/Content/Main/ContentMain'
import ContentToast from '../../shared/components/Content/Toast/ContentToast'
import ModalExport from '../../shared/components/Modal/ModalExport'
import ActionBar from '../../shared/components/Reporting/Actionbar/Actionbar'
import AreaChart from '../../shared/components/Reporting/AreaChart/AreaChart'
import NoRatingsBanner from '../../shared/components/Reporting/Banner/NoRatingsBanner'
import Header from '../../shared/components/Reporting/Header/Header'
// import Sentiment from '../../shared/components/Reporting/Sentiment/Sentiment'
import TableApplications from '../../shared/components/Reporting/Table/TableApplications/TableApplications'
import TableDepartment from '../../shared/components/Reporting/Table/TableDepartment/TableDepartment'
import TableSingleRatings from '../../shared/components/Reporting/Table/TableSingleRatings/TableSingleRatings'
import TableSubApps from '../../shared/components/Reporting/Table/TableSubApps/TableSubApps'
// import WordCloud from '../../shared/components/Reporting/WordCloud/WordCloud'
import { ReportingContext } from '../../shared/utils/Context/ReportingContext'
import { getData, getApplications } from '../../shared/utils/getData'
import RatingSidebar from './RatingSidebar/RatingSidebar'

import { PortalContext, UserRole } from '../../shared/utils/PortalContext'

import styles from './reporting.module.css'

export default function ReportingContent() {
  const { loading, setLoading, userRole, setError, setToast, setToastContent, error, setAccessToken } =
    React.useContext(PortalContext)

  // Initiales Datum today - 90 Tage
  const period = 90
  const start = new Date(new Date(new Date().setDate(new Date().getDate() - period)).setHours(0, 0, 0, 0))
  const end = new Date(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59, 59, 999))

  const defaultDepartment = 'Alle Abteilungen'
  const defaultApplication = 'Alle Applikationen'

  const [startDate, setStartDate] = React.useState(start)
  const [params, setParams] = React.useState(queryString.parse(useLocation().search))
  const [endDate, setEndDate] = React.useState(end)
  const [datePeriod, setDatePeriod] = React.useState(period)
  const app = isNaN(parseInt(params?.application)) ? [] : [parseInt(params?.application)]
  const subApp = isNaN(parseInt(params?.subapp)) ? [] : [parseInt(params?.subapp)]
  const module = isNaN(parseInt(params?.module)) ? [] : [parseInt(params?.module)]
  const [filter, setFilter] = React.useState(() => ({
    from: start.getTime(),
    to: end.getTime(),
    app: app,
    subApp: subApp,
    module: module,
    includeAppHierarchy: true,
    department: [],
    includedepartmenthierarchy: true,
    responsible: ''
  }))

  const history = useHistory()

  const [appId, setAppId] = React.useState(isNaN(parseInt(params?.application)) ? 0 : parseInt(params?.application))
  const [openSubApps, setOpenSubApps] = React.useState(false)
  const [reportingData, setReportingData] = React.useState({})
  const [chosenDepartment, setChosenDepartment] = React.useState('')
  const [chosenApplication, setChosenApplication] = React.useState('')

  const [cellContentAppWithSubApps, setCellContentAppWithSubApps] = React.useState([])

  // changes with every render when filter is changed
  const [areaChart, setAreaChart] = React.useState([])
  const [ratingCount, setRatingCount] = React.useState({})
  const [ratingCountHistory, setRatingCountHistory] = React.useState(0)
  const [applicationList, setApplicationList] = React.useState([])
/*   const [departmentList, setDepartmentList] = React.useState([])
  const [teamDepartmentList, setTeamDepartmentList] = React.useState([]) */
  const [singleRatings, setSingleRatings] = React.useState([])
  const [totalRatings, setTotalRatings] = React.useState(0)
  const [ratingAverage, setRatingAverage] = React.useState([])
  const [ratingAverageHistory, setRatingAverageHistory] = React.useState([])
  const [contentHeader, setContentHeader] = React.useState('')
  const [sentiment, setSentiment] = React.useState([])
  const [sentimentHistory, setSentimentHistory] = React.useState([])
  const [keyPhrases, setKeyPhrases] = React.useState([])
  const [resetParams, setResetParams] = React.useState(false)

  // not changes again
  const [appFilterList, setAppFilterList] = React.useState([])
  // const [departmentFilterList, setDepartmentFilterList] = React.useState([])
  const [allApplications, setAllApplications] = React.useState([])

  const [departmentButton, setDepartmentButton] = React.useState(defaultDepartment)
  const [applicationButton, setApplicationButton] = React.useState(defaultApplication)
  const [openFilterMenu, setOpenFilterMenu] = React.useState(false)
  const [showSingleRatings, setShowSingleRatings] = React.useState(false)/* 
  const [showDepartmentList, setShowDepartmentList] = React.useState(true)
  const [showTeamDepartmentList, setShowTeamDepartmentList] = React.useState(false) */

  // filter menu
  const [openApplicationMenu, setOpenApplicationMenu] = React.useState(false)
  const [openDepartmentMenu, setOpenDepartmentMenu] = React.useState(false)

  const [calendarIsOpen, setCalendarIsOpen] = React.useState(false)

  /* API Calls and saving in reportingData */

  const parseResponse = (res) => {
    return res
      .clone()
      .json()
      .catch(() => res.text())
  }

  // set departmentListMenu data

  React.useEffect(() => {
    if (error === false) {
      setLoading(true)
/*       getDepartmentList()
        .then((res) => parseResponse(res))
        .then((data) => {
          if (data instanceof Array) {
            data.sort().unshift(defaultDepartment)
            setDepartmentFilterList(data)
          }
        }) */
      let cellData
      let filterDetails = {...filter}
      if (loading) {
        return
      }
      if (appId !== 0) {
        filterDetails = { ...filter, app: [appId] }
      }
      // getReporting(filterDetails, 'appdetails')
      //   .then((res) => parseResponse(res))
      //   .then((data) => {
      //     if (data === 'no Data selected') {
      //       return null
      //     } else if (data !== undefined && data.applications !== undefined) {
      //       checkForInstantAppView(data?.applications[0])
      //       cellData = [
      //         {
      //           additionalInformation: {},
      //           col0: data?.applications[0].appDescription,
      //           col1: data?.applications[0].areaAverageRating?.toFixed(2),
      //           col2: data?.applications[0].averageRating?.toFixed(2),
      //           col3: data?.applications[0].count.toString()
      //         }
      //       ]

      //       data?.applications[0].subApp?.length > 0 &&
      //         data?.applications[0].subApp?.map((subApp) => {
      //           cellData.push({
      //             additionalInformation: {
      //               appType: 'subApp',
      //               id: subApp?.subAppId
      //             },
      //             col0: subApp?.subAppDescription === '' ? 'Subapp without name' : subApp?.subAppDescription,
      //             col1: subApp.modules.length > 0 ? subApp?.areaAverageRating?.toFixed(2) : ' ',
      //             col2: subApp?.averageRating?.toFixed(2),
      //             col3: subApp?.count.toString()
      //           })

      //           subApp?.modules?.length > 0 &&
      //             subApp?.modules?.map((module) => {
      //               cellData.push({
      //                 additionalInformation: {
      //                   appType: 'module',
      //                   subAppId: subApp.subAppId,
      //                   subAppName: subApp.subAppDescription,
      //                   id: module?.moduleId
      //                 },
      //                 col0: module?.moduleDescription,
      //                 col1: '',
      //                 col2: module?.averageRating?.toFixed(2),
      //                 col3: module?.count.toString()
      //               })
      //             })
      //         })

      //       setCellContentAppWithSubApps(cellData)
      //     }
      //   })
      getData(filter, datePeriod)
        .then((val) => {
          // areaChart data
          if (val.areaChartData === undefined || val.areaChartData.length === 0) {
            setAreaChart([])
          } else if (val.areaChartData.length > 0 && val.areaChartData instanceof Array) {
            setAreaChart(val.areaChartData)
          }

          // ratingsAverage data
          if (val.ratingsAverage.average === null) {
            setRatingAverage(0)
          } else if (val.ratingsAverage) {
            setRatingAverageHistory(val.ratingsAverageHistory[0].average)
            setRatingAverage(val.ratingsAverage[0].average)
          }

          // ratingcount data
          if (val.ratingsCount === undefined) {
            setRatingCount({})
          } else if (val.ratingsCount) {
            setRatingCountHistory(val.ratingCountHistory)
            setRatingCount(val.ratingsCount[0])
            setTotalRatings(val.ratingsCount[0].count)
          }

          // singleRatings state List
          if (val.allSingleRatings === undefined || val.allSingleRatings.length === 0) {
            setSingleRatings([])
          } else if (val.allSingleRatings.length > 0 && val.allSingleRatings instanceof Array) {
            setSingleRatings(
              val?.allSingleRatings?.map((rating) => {
                return {
                  additionalInformation: {
                    subapp: rating.subappName,
                    module: rating.moduleName
                  },
                  col0: rating.appName,
                  col1: rating.rating,
                  col2: rating.comment,
                  col3: rating.date
                }
              })
            )
          }

          // applicationlistdata state List
          if (val.applicationListData === undefined || val.applicationListData.length === 0) {
            setApplicationList([])
          } else if (val.applicationListData.length > 0 && val.applicationListData instanceof Array) {
            console.log(val?.applicationListData);
            setApplicationList(
              val?.applicationListData.map((app) => {
                return {
                  additionalInformation: app,
                  col0: app.appName,
                  col1: app.avarage.toFixed(2),
                  col2: app.ratingCount.toString()
                }
              })
            )
          }

          /* // teamDepartmentListData state List
          if (val.teamDepartmentListData === undefined) {
            setTeamDepartmentList([])
          } else if (val.teamDepartmentListData.length > 0 && val.teamDepartmentListData instanceof Array) {
            setTeamDepartmentList(
              val?.teamDepartmentListData.map((department) => {
                return {
                  additionalInformation: department,
                  col0: department.department,
                  col1: department.avarage.toFixed(2),
                  col2: department.count.toString(),
                  col3: department.appsCount.toString()
                }
              })
            )
          }

          // departmentListData state List
          if (val.departmentListData === undefined) {
            setDepartmentList([])
          } else if (val.departmentListData.length > 0 && val.departmentListData instanceof Array) {
            setDepartmentList(
              val?.departmentListData.map((department) => {
                return {
                  additionalInformation: department,
                  col0: department.department,
                  col1: department.avarage.toFixed(2),
                  col2: department.count.toString(),
                  col3: department.appsCount.toString()
                }
              })
            )
          } */

          setLoading(false)
          setReportingData(val)
        })
        .catch((err) => {
          setError(true)
          setToastContent(err.message)
          setToast(true)
        })
    }
  }, [filter])

  const createSentimentArray = (data) => {
    if (data.positive === undefined && data.negative === undefined && data.neutral === undefined) {
      return []
    } else {
      return [
        {
          name: 'Positiv',
          value: data.positive || 0
        },
        {
          name: 'Negativ',
          value: data.negative || 0
        },
        {
          name: 'Neutral',
          value: data.neutral || 0
        }
      ]
    }
  }

  const subtractDays = (numOfDays, date = new Date()) => {
    date.setDate(date.getDate() - numOfDays)
    return date
  }

  const sentimentAnalysis = async function () {
    let analysisObj = {}
    const actualSentiment = getSentiment(filter)
      .then((res) => parseResponse(res))
      .then((val) => {
        return (analysisObj = {
          ...analysisObj,
          sentiment: createSentimentArray(val)
        })
      })
    const historySentiment = getSentiment({
      ...filter,
      from: subtractDays(datePeriod, new Date(filter.from)).getTime(),
      to: filter.from
    })
      .then((res) => parseResponse(res))
      .then((val) => {
        return (analysisObj = {
          ...analysisObj,
          sentimentHistory: createSentimentArray(val)
        })
      })
    const actualKeyPhrases = getKeyPhrases(filter)
      .then((res) => parseResponse(res))
      .then((val) => {
        return (analysisObj = {
          ...analysisObj,
          keyPhrases: val
        })
      })
    await Promise.all([actualSentiment, actualKeyPhrases, historySentiment])
    return analysisObj
  }

  React.useEffect(() => {
    if (singleRatings.length > 1 && showSingleRatings) {
      sentimentAnalysis().then((val) => {
        setSentimentHistory(val.sentimentHistory)
        setKeyPhrases(val.keyPhrases)
        setSentiment(val.sentiment)
      })
    }
  }, [showSingleRatings, singleRatings])

  const checkForInstantAppView = (dataApps) => {
    if (!isNaN(parseInt(params?.application)) && !resetParams) {
      setChosenApplication(dataApps.appDescription)
      setContentHeader(createContentHeader(dataApps, parseInt(params?.subapp), parseInt(params?.module)))
      setChosenDepartment('')
      setOpenSubApps(dataApps.appDescription !== 'Alle Applikationen' && true)
      setApplicationButton(dataApps.appDescription)
      setDepartmentButton('Alle Abteilungen')
      setOpenFilterMenu(false)
      setShowSingleRatings(true)
      // setShowDepartmentList(false)
    }
  }

  React.useEffect(() => {
    getApplications({ ...filter, app: [], subApp: [], module: [] }).then((val) => {
      if (val === 'not authorized') {
        setAccessToken(val)
        return
      }
      if (val !== undefined) {
        const applicationName = val.map((app) => {
          return {
            appName: app.appName,
            appNumber: app.app
          }
        })
        applicationName.sort().unshift({ appName: defaultApplication, appNumber: '' })

        setAppFilterList(applicationName)
        setAllApplications(val)
      }
    })
  }, [])

  React.useEffect(() => {
    if (userRole === UserRole.ApplicationManager) {
      setShowSingleRatings(true)
    } else if (userRole === UserRole.Manager || userRole === UserRole.KeyUser) {
      setShowSingleRatings(false)
    }
  }, [userRole])

  React.useEffect(() => {
    if (resetParams) {
      history.replace({
        search: ''
      })
      setParams({})
    }
  }, [resetParams])

  // Load SubApp structure with rating counts when an app is selected
  React.useEffect(() => {
    if (openSubApps && appId !== 0) {
      getAll()
        .then((res) => res.json())
        .then(async (apps) => {
          const selectedApp = apps.find((a) => a.app === appId)
          if (!selectedApp || !selectedApp.subApp) return

          // Collect all configIds from the app hierarchy
          const configIdMap = new Map()
          configIdMap.set(selectedApp.configId, { type: 'app', label: selectedApp.appDescription })
          selectedApp.subApp.forEach((subApp) => {
            if (!subApp.active) return
            if (subApp.configId) {
              configIdMap.set(subApp.configId, { type: 'subApp', id: subApp.subAppId })
            }
            if (subApp.modules) {
              subApp.modules.forEach((mod) => {
                if (!mod.active) return
                if (mod.configId) {
                  configIdMap.set(mod.configId, { type: 'module', id: mod.moduleId, subAppId: subApp.subAppId })
                }
              })
            }
          })

          // Fetch rating counts for all configIds in one call
          const allConfigIds = Array.from(configIdMap.keys())
          let ratingsMap = new Map()
          try {
            const ratingsRes = await getRatingsByConfigIds(allConfigIds, filter.from, filter.to)
            const ratingsData = await ratingsRes.json()
            if (Array.isArray(ratingsData)) {
              ratingsData.forEach((r) => ratingsMap.set(r.configId, r))
            }
          } catch (e) {
            console.error('Failed to load ratings by configIds', e)
          }

          // Build cell data with rating counts
          const appRatings = ratingsMap.get(selectedApp.configId)
          const cellData = [
            {
              additionalInformation: {},
              col0: selectedApp.appDescription,
              col1: appRatings ? appRatings.count.toString() : '0'
            }
          ]
          selectedApp.subApp.forEach((subApp) => {
            if (!subApp.active) return
            const subRatings = ratingsMap.get(subApp.configId)
            cellData.push({
              additionalInformation: {
                appType: 'subApp',
                id: subApp.subAppId
              },
              col0: subApp.subAppDescription || 'Subapp ohne Name',
              col1: subRatings ? subRatings.count.toString() : '0'
            })
            if (subApp.modules) {
              subApp.modules.forEach((mod) => {
                if (!mod.active) return
                const modRatings = ratingsMap.get(mod.configId)
                cellData.push({
                  additionalInformation: {
                    appType: 'module',
                    subAppId: subApp.subAppId,
                    subAppName: subApp.subAppDescription,
                    id: mod.moduleId
                  },
                  col0: mod.moduleDescription,
                  col1: modRatings ? modRatings.count.toString() : '0'
                })
              })
            }
          })
          setCellContentAppWithSubApps(cellData)
        })
        .catch((err) => console.error(err))
    }
  }, [openSubApps, appId, filter.from, filter.to])

  const createContentHeader = (apps, subAppId, moduleId) => {
    let title = apps.appDescription
    if (!isNaN(subAppId) && apps.subApp !== undefined) {
      for (let index = 0; index < apps.subApp.length; index++) {
        const subApp = apps.subApp[index]
        if (subApp.subAppId === subAppId) {
          title += ' / ' + subApp.subAppDescription
          if (!isNaN(moduleId) && subApp.modules !== undefined) {
            for (let modIndex = 0; modIndex < subApp.modules.length; modIndex++) {
              const module = subApp.modules[modIndex]
              if (module.moduleId === moduleId) {
                title += ' / ' + module.moduleDescription
                break
              }
            }
          }
          break
        }
      }
    }
    return title
  }

  return (
    <ReportingContext.Provider
      value={{
        filter,
        setFilter,
        reportingData,
        setReportingData,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        datePeriod,
        setDatePeriod,
        appId,
        setAppId,
        openSubApps,
        setOpenSubApps,
        chosenDepartment,
        setChosenDepartment,
        chosenApplication,
        setChosenApplication,
        departmentButton,
        setDepartmentButton,
        applicationButton,
        setApplicationButton,
        cellContentAppWithSubApps,
        setCellContentAppWithSubApps,
        totalRatings,
        setTotalRatings,
        openFilterMenu,
        setOpenFilterMenu,
        showSingleRatings,
        setShowSingleRatings,
        showDepartmentList: false,
        setShowDepartmentList: () => {},
        showTeamDepartmentList: false,
        setShowTeamDepartmentList: () => {},
        applicationList,
        setApplicationList,
        openApplicationMenu,
        setOpenApplicationMenu,
        openDepartmentMenu,
        setOpenDepartmentMenu,
        calendarIsOpen,
        setCalendarIsOpen,
        contentHeader,
        setContentHeader,
        setResetParams,
        singleRatings,
        setSingleRatings
      }}
    >
      <Content>
        <ActionBar appList={appFilterList} />
        <ContentMain>
          <PGrid>
            {singleRatings.length === 0 && !loading && <NoRatingsBanner />}
            <Header loading={loading} />
            <PGridItem size={8}>
              <PHeadline variant='headline-5'>Zeitverlauf</PHeadline>
              <AreaChart
                data={areaChart || []}
                totalRatings={ratingCount.count || 0}
                startDate={startDate}
                endDate={endDate}
                totalRatingsHistory={ratingCountHistory || 0}
                loading={loading}
              />
            </PGridItem>

            <PGridItem size={4}>
              <PHeadline variant='headline-5'>Rating</PHeadline>
              {/* normal view with data  */}
              {!loading && ratingCount && singleRatings.length > 0 && ratingAverage && (
                <RatingSidebar data={ratingCount} average={ratingAverage} averageHistory={ratingAverageHistory} />
              )}
              {/* loading view */}
              {loading && <RatingSidebar loading={loading} data={{}} />}
              {/* no data view */}
              {singleRatings.length === 0 && !loading && <RatingSidebar loading={loading} data={{}} />}
            </PGridItem>

            {/* {(userRole === UserRole.Manager || userRole === UserRole.KeyUser) &&
              !showSingleRatings &&
              showDepartmentList && (
                <PGridItem size={12} className={styles.table}>
                  <TableDepartment content={departmentList} loading={loading} />
                </PGridItem>
              )}

            {(userRole === UserRole.Manager || userRole === UserRole.KeyUser) &&
              !showSingleRatings &&
              showTeamDepartmentList && (
                <PGridItem size={12} className={styles.table}>
                  <TableDepartment content={teamDepartmentList} loading={loading} team />
                </PGridItem>
              )} */}

            {!openSubApps && (
              <PGridItem size={12} className={styles.table}>
                <TableApplications content={applicationList} loading={loading} />
              </PGridItem>
            )}

            {/* subApps - only show when no specific subApp/module is selected */}
            {openSubApps && cellContentAppWithSubApps.length > 1 && filter.subApp.length === 0 && filter.module.length === 0 && (
              <PGridItem size={12} className={styles.table}>
                <TableSubApps content={cellContentAppWithSubApps} loading={loading} />
              </PGridItem>
            )}

            {/* {showSingleRatings && (
              <React.Fragment>
                {sentiment.length !== 0 && (
                  <PGrid className={styles.gridChild}>
                    <PGridItem size={12} className={styles.table}>
                      <PHeadline variant='headline-5'>Analyse der Kommentare</PHeadline>
                    </PGridItem>
                    <PGridItem size={4}>
                      <CommentSummary sentiments={sentiment} sentimentsHistory={sentimentHistory} />
                    </PGridItem>
                    <PGridItem size={4}>
                      <Sentiment data={sentiment} loading={loading} />
                    </PGridItem>
                    <PGridItem size={4}>
                      <WordCloud data={keyPhrases} loading={loading} />
                    </PGridItem>
                  </PGrid>
                )}
              </React.Fragment>
            )} */}
            {showSingleRatings && (
              <PGridItem size={12} className={styles.tableWithButton}>
                <TableSingleRatings content={singleRatings} loading={loading} />
              </PGridItem>
            )}
            <PGridItem size={12} className={styles.footer}>
              <PFlex inline>
                <PFlexItem className={styles.copyRight}>
                  <PText>© 2026 Porsche</PText>
                </PFlexItem>
              </PFlex>
            </PGridItem>
          </PGrid>
        </ContentMain>
        <ContentToast />
        <ModalExport />
      </Content>
    </ReportingContext.Provider>
  )
}
